var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.352 923.136C298.538667 923.136 128 837.888 128 736.981333V271.488C128 170.581333 298.538667 85.333333 500.352 85.333333s372.352 85.248 372.352 186.154667v465.493333c0 100.906667-170.453333 186.154667-372.352 186.154667z m-279.253333-297.386667v111.36c3.242667 23.168 107.477333 93.098667 279.253333 93.098667 171.818667 0 276.053333-70.144 279.296-93.354667v-111.104a581.888 581.888 0 0 1-279.296 64.768 581.802667 581.802667 0 0 1-279.253333-64.810666z m0-232.874666v111.36C224.341333 527.402667 328.533333 597.333333 500.352 597.333333c171.818667 0 276.053333-70.144 279.296-93.354666V392.874667a581.76 581.76 0 0 1-279.296 64.853333 581.717333 581.717333 0 0 1-279.253333-64.853333z m279.253333-214.442667c-171.818667 0-276.053333 70.101333-279.253333 93.354667 3.242667 23.04 107.52 92.8 279.253333 92.8s276.053333-70.144 279.296-93.354667c-3.285333-23.04-107.562667-92.8-279.296-92.8z",
    fill: "#ffffff",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.3c783eb6f9c6e632170650fa64dfb13f.svg";
export { ForwardRef as ReactComponent };